import { IconTargetArrow } from "@tabler/icons-react";
import { Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";

import { contractTypeText } from "../../i18n/enumText";
import type { ToolCategory } from "../../types";
import styles from "./ToolManifest.module.css";

export function ToolManifest({ category }: { category: ToolCategory }): JSX.Element | null {
  const { i18n } = useLingui();
  if (category === "upcoming") {
    return null;
  }
  const minigame = i18n._(contractTypeText(category));
  return (
    <span className={styles.manifest}>
      <IconTargetArrow size={15} aria-hidden="true" />
      <Trans>Работает в: {minigame}</Trans>
    </span>
  );
}
